import { ReduxFormField } from "components/molecules/ReduxFormFields/index";
import CheckboxRedux from "components/molecules/CheckboxRedux";
export { default } from "./UpdatePaymentLinkForm";

export const fields = (): ReduxFormField[] => [
  {
    name: "send_email",
    label: "Send Email?",
    component: CheckboxRedux,
    cellProps: { md: 12 },
  },
];
